export interface PaginatedResponse<T = any> {
  count: number;
  next: number | null;
  previous: number | null;
  results: T;
}

export interface ICourseRoster {
  course: string;
  id: number;
  training_name: string;
  batch_name: string;
  start_date: string;
  end_date: string;
  hall: any;
  coordinators: string[];
  module_coordinator: string[];
  routine_sessions: RoutineSession[];
}

export interface RoutineSession {
  id: number;
  session_name: string;
  start_time: string;
  end_time: string;
  daily_sessions: DailySession[];
}
export interface Dashboardcount {
  attendance_count: number;
  message: string;
  status: string;
  statuscode: number;
  trainee_enroll_count: number;
}

export interface DailySession {
  routine_date: string;
  lecturers: string[];
  altered_start_time?: string;
  course_topic?: string;
  altered_end_time: any;
}

export interface TMSResponse<T = any> {
  results: any;
  data: T;
  status: 0 | 1;
  message: string;
  first_login_attempt?: boolean;
}
import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from 'redux/reducers/settings'; // As per your example

// --- Interfaces (Placeholders based on your usage) ---
// You should import these from your actual types file
export interface Dashboardcount {
  [key: string]: any;
}
export interface TraineeModule {
  data: any;
}
export interface CourseSession {
  data: any;
}
export interface TrainingRoutine {
  routines: any;
}
export interface IRoutineByID {
  data: any;
}
export interface IDailySessions {
  data: any;
}
export interface ITrainingDetail {
  results: { data: any };
}
export interface ICourseRoster {
  [key: string]: any;
}

// --- Arguments Interfaces ---
interface ICourseSessionArgs {
  courseId: string;
}
interface ITrainingRoutineArgs {
  filter: string;
}
interface IRoutineByIdArgs {
  routine_id: number | undefined;
}
interface IDailySessionArgs {
  routine_id: number;
  date: any;
}
interface ITrainingDetailArgs {
  training_id: string;
}
interface IRoutineCourseArgs {
  routineId: string;
  courseId: string;
}
interface IAdminDetailArgs {
  id: string;
}
const defaultTMSResponse = {
  data: [],
  status: 0,
  message: ''
};

export const userTrainingApi = createApi({
  reducerPath: 'userTrainingApi',
  baseQuery: baseQuery,
  tagTypes: [
    'Dashboard',
    'TraineeModule',
    'CourseSession',
    'TrainingRoutine',
    'Routine',
    'DailySession',
    'TrainingDetail',
    'Roster',
    'Admin',
    'TrainingRoutineApplication'
  ],
  endpoints: (build) => ({
    // 1. Dashboard Count
    getDashboardCount: build.query<Dashboardcount, void>({
      query: () => 'training/trainee/dashboard/count/',
      providesTags: ['Dashboard'],
      // providesTags: (response, error, page) => response.data

      transformResponse: (response: { data: Dashboardcount }) => {
        return response.data;
      }
    }),

    // 2. Trainee Module
    getTraineeModule: build.query<any, void>({
      query: () => 'trainee/module', // Replace with api.traineeModule
      providesTags: ['TraineeModule'],
      // Logic from: select: (item) => item?.data.data
      transformResponse: (response: { data: { data: any } }) => response.data.data
    }),

    // 3. Course Session
    getCourseSession: build.query<any, string>({
      query: (courseId) => `course/session/${courseId}`, // Replace api.courseSession logic
      providesTags: (result, error, id) => [{ type: 'CourseSession', id }],
      // Logic from: select: (item) => item?.data.data
      transformResponse: (response: { data: { data: any } }) => response.data.data
    }),
    getTrainingRoutine: build.query<any[], string>({
      query: (routineFilter) => ({
        url: `users/trainee/routines/`,
        params: { filter: routineFilter }
      }),

      providesTags: ['TrainingRoutine'],
      transformResponse: (response: { data: { routines: any[] } }) => {
        return response?.data?.routines ?? [];
      }
    }),

    getTrainingRoutineApplication: build.query<any[], string>({
      query: (routineFilter) => ({
        url: `training/application/routines`,
        params: { filter: routineFilter }
      }),

      providesTags: ['TrainingRoutineApplication'],
      transformResponse: (response: { data: any[] }) => {
        return response?.data ?? [];
      }
    }),

    applyForTraining: build.mutation<any, any>({
      query: (data) => ({
        url: 'training/application/apply',
        method: 'POST',
        body: data
      }),
      invalidatesTags: ['TrainingRoutineApplication']
    }),

    cancelForTraining: build.mutation<any, any>({
      query: (routineId) => ({
        url: `training/application/cancel/${routineId}`,
        method: 'DELETE'

        // body: data
      }),
      invalidatesTags: ['TrainingRoutineApplication']
    }),

    // 5. Routine By ID
    getRoutineById: build.query<any, number | undefined>({
      query: (routine_id) => `/training/trainee/routine-master/${routine_id}/`,
      providesTags: (result, error, id) => [{ type: 'Routine', id }],
      transformResponse: (response: { data: { data: any } }) => {
        return response.data.data;
      }
    }),

    // 6. Daily Sessions
    getDailySessions: build.query<any, IDailySessionArgs>({
      query: ({ routine_id, date }) => ({
        url: `training/routine-master/${routine_id}/daily-sessions/`,
        params: { date }
      }),

      providesTags: ['DailySession'],
      transformResponse: (response:any) =>  {
        console.log('res',response);
        
        return response.data
      
      }
      
    }),

    // 7. Training Detail
    getTrainingDetail: build.query<any, string>({
      query: (training_id) => `training/detail/${training_id}/`, // Replace api.trainingDetail
      providesTags: (result, error, id) => [{ type: 'TrainingDetail', id }],
      // Logic from: select: (item) => item.data.results.data
      transformResponse: (response: { data: { results: { data: any } } }) =>
        response.data.results.data
    }),

    // 8. Routine Course Session List
    getRoutineCourseSessionList: build.query<any, IRoutineCourseArgs>({
      query: ({ routineId, courseId }) =>
        `routine-course-session/${courseId}/?routine=${routineId}`, // Replace api.routineCourseSessionList
      // Logic from: select: (response) => response.data
      transformResponse: (response: { data: any }) => response.data
    }),

    // 9. Lecturers By Module (Coordinator List)
    getLecturersByModule: build.query<any, IRoutineCourseArgs>({
      query: ({ routineId, courseId }) => `lecturers-by-module/${courseId}/?routine=${routineId}`, // Replace api.lecturersbyModule
      // Logic from: select: (response) => response.data
      transformResponse: (response: { data: any }) => response.data
    }),

    // 10. Admin Detail By ID
    getAdminDetailById: build.query<any, string>({
      query: (id) => `admin/detail/${id}/`, // Replace api.adminDetailById
      providesTags: (result, error, id) => [{ type: 'Admin', id }],
      // Logic from: select: (response) => response.data
      transformResponse: (response: { data: any }) => response.data
    }),
    // 11. Course Roster
    getCourseRoster: build.query<ICourseRoster, IRoutineCourseArgs>({
      query: ({ routineId, courseId }) => `course-roster/${routineId}/${courseId}`, // Replace api.courseRoster logic
      providesTags: ['Roster'],
      // Logic from: select: (response) => response.data.data
      transformResponse: (response: TMSResponse<ICourseRoster>) => response.data.data
    })
  })
});

// Export hooks for usage in functional components
export const {
  useGetDashboardCountQuery,
  useGetTraineeModuleQuery,
  useGetCourseSessionQuery,
  useGetTrainingRoutineQuery,
  useGetRoutineByIdQuery,
  useGetDailySessionsQuery,
  useGetTrainingDetailQuery,
  useGetRoutineCourseSessionListQuery,
  useGetLecturersByModuleQuery,
  useGetAdminDetailByIdQuery,
  useGetCourseRosterQuery,
  useGetTrainingRoutineApplicationQuery,
  useApplyForTrainingMutation,
  useCancelForTrainingMutation
} = userTrainingApi;
